@use '@lib/assets/styles/main.scss' as *;
.actionView {
  border: 1px solid $gray200;
  border-radius: 6px;
  overflow: hidden;
}

.actionViewHeader {
  border-bottom: 1px solid $gray100;
  grid-gap: 8px;
  align-items: center;
  display: grid;
  @include responsive($md1) {
    grid-template-columns: auto min-content min-content;
    padding: 12px 8px 12px 16px;
  }
  @include responsive(null, $md1) {
    grid-template-columns: auto min-content;
    padding: 8px 8px 12px 12px;
  }
}

.actionViewHeaderInfo {
  @include responsive(null, $md1) {
    grid-column: 1 / 2;
    grid-row: 2/ 3;
  }
}

.actionViewHeaderStatus {
  @include responsive(null, $md1) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    & > div {
      display: flex;
    }
  }
}

.actionViewHeaderActionsMenu {
  @include responsive(null, $md1) {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }
}

.actionAssignees {
  border-bottom: 1px solid $gray100;
  @include responsive($md1) {
    padding: 12px 8px 12px 16px;
  }
  @include responsive(null, $md1) {
    padding: 12px 8px;
  }
}

.dateUpdated {
  color: $gray400;
  padding-left: 32px;
}

.actionViewBody {
  background-color: $gray10;
}

.actionViewBodyContent {
  padding: 12px;
}

.tabBar {
  margin-bottom: 0;
}

.actionDescription {
  color: $gray700;
  padding: 12px;
}

.assigneesInfoItemLabel {
  @include responsive(null, $md1) {
    width: auto;
  }
}
